import styled from "styled-components";

import metrics from "../../styles/metrics";
import colors from "../../styles/colors";

export const Container = styled.div`
  display: flex;
  background: ${colors.primary};
  height: 80px;
  padding: ${metrics.baseMargin}px;
  justify-content: center;
  align-items: center;
`;

export const LogosContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NameContainer = styled.p`
  flex: 1;
  text-align: center;
  color: ${colors.text.white};
`;
